var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`wphk-act-coupon-${_vm.couponLang}`},[_c('Coupon',{attrs:{"lang":_vm.couponLang,"couponInfo":_vm.formattedCouponInfo},on:{"getCoupon":_vm.btnClick,"couponClick":_vm.couponClick}},[_c('template',{slot:"coupon-btn-ui"},[_vm._t("basic-coupon-btn-comp")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }